type Exact<T, U> = T extends object ? T & Record<Exclude<keyof U, keyof T>, never> : T;

type Selector<T, R> = (data: T) => R;

class DataMapper<T, R> {
  constructor(private readonly selector: Selector<T, R>) {}

  get select(): Selector<T, R> {
    return this.selector;
  }

  pipe<N>(next: Selector<R, N>): DataMapper<T, N> {
    return new DataMapper((data: T) => next(this.selector(data)));
  }
}

export function createMapper<T, R>(selector: Selector<T, Exact<R, R>>): DataMapper<T, R> {
  return new DataMapper(selector);
}
